import{ML2_SID_C as o}from"../../utils/cookieConstants.js";const t=t=>{var i;const n=null===(i=null==t?void 0:t.cookies)||void 0===i?void 0:i[o];return n||{}};export{t as getAccountData};
